import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, addURI, BaseQueryParams} from "@commons/utils/APIParams";
import {RetribuzioneLavoratore} from "@commons/mapping/DataTablesSchema";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";
import {config} from "@commons/config.instance";


export interface LavoratoreFilterSelection extends BaseQueryParams {
    idDip: number | null,
}

export interface RMLLavoratoreFilterSelection extends LavoratoreFilterSelection {
    soloVariazioni: boolean | null,
    nowId: string | null,
}


export const RMLLavoratoreApi = createApi({
    reducerPath: 'RMLLavoratoreApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('HR')}),
    endpoints: (builder) => ({

        getRetribuzioni: builder.query<RetribuzioneLavoratore, Partial<RMLLavoratoreFilterSelection>>({
            query: (filter) => {
                let params: string[] = [];
                if (filter.soloVariazioni) params.push('soloVariazioni=true');
                addBaseQueryParams(filter, params);

                return `/lavoratore/${filter.idDip}/rml?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),

        getRetribuzioniByElementi: builder.query<RetribuzioneLavoratore, Partial<RMLLavoratoreFilterSelection>>({
            query: (filter) => {
                let params: string[] = [];
                if (filter.nowId)
                    params.push(`nowId=${filter.nowId}`);
                addBaseQueryParams(filter, params);

                return `/lavoratore/${filter.idDip}/rml-by-elementi?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),

        getSingoliElementi: builder.query<DettaglioRetribuzioneRecord, string | undefined>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
        }),

    }),
})
export const {
    useGetRetribuzioniQuery,
    useLazyGetRetribuzioniQuery,
    useGetRetribuzioniByElementiQuery,
    useLazyGetRetribuzioniByElementiQuery,
    useLazyGetSingoliElementiQuery,
} = RMLLavoratoreApi;
// N.B. useLazyGetFotoLavoratoreQuery NON VIENE UTILIZZATA perchè si usa direttamente il tag IMG con il relativo indirizzo, vedi useFotoLavoratore